import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui';
import { useMerchants } from '@/hooks/use-merchants';

interface MerchantSelectProps {
  value: string | undefined;
  onChange: (merchantId: string | undefined) => void;
  placeholder?: string;
  includeAll?: boolean;
  disabled?: boolean;
  className?: string;
}

export function MerchantSelect({
  value,
  onChange,
  includeAll = true,
  disabled,
  placeholder,
  className,
}: MerchantSelectProps) {
  const { t } = useTranslation('merchants');
  const { data, isLoading } = useMerchants({ status: 'all', limit: 100 });

  const handleChange = (val: string) => {
    onChange(val === '__all__' ? undefined : val);
  };

  return (
    <Select
      value={value ?? (includeAll ? '__all__' : '')}
      onValueChange={handleChange}
      disabled={disabled || isLoading}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={isLoading ? t('select.loading') : (placeholder ?? t('select.placeholder'))} />
      </SelectTrigger>
      <SelectContent>
        {includeAll && (
          <SelectItem value="__all__">{t('select.all')}</SelectItem>
        )}
        {data?.data.map((merchant) => (
          <SelectItem key={merchant.merchantId} value={merchant.merchantId}>
            {merchant.name} ({merchant.merchantId})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
